import { lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ModalProvider } from './components/ModalProvider';

import Header from './components/Header';
import Footer from './components/Footer';
import BrowseEvents from './routes/BrowseEvents';
import Subscription from './routes/Subscription';
import Venue from './routes/Venue';
import Gratuit from './routes/Gratuit';
import Familiales from './routes/Familiales';
import ForOrganizers from './routes/ForOrganizers';

const About = lazy(() => import('./routes/About'));
const PrivacyPolicy = lazy(() => import('./routes/PrivacyPolicy'));
const Details = lazy(() => import('./routes/Details'));
const NewEvent = lazy(() => import('./routes/NewEvent'));
const Presse = lazy(() => import('./routes/Presse'));
const MesAlentours = lazy(() => import('./routes/MesAlentours'));
const ThisWeek = lazy(() => import('./routes/ThisWeek'));
const Today = lazy(() => import('./routes/Today'));

const App: React.FC = () => {
    return (
        <BrowserRouter>
        <div className="layout">
            <ModalProvider>
                <Header />
                {/* <GoogleAdsense /> */}
                <div id="page">
                    <Suspense fallback={<div className="page-skeleton" aria-hidden="true" ></div>}>
                        <Routes>
                            <Route path="/" element={<BrowseEvents />} />
                            {<Route path="/details/:id" element={<Details />} />}
                            {<Route path="/venue/:name" element={<Venue />} />}
                            <Route path="/a-propos-de-nous" element={<About />} />
                            <Route path="/presse" element={<Presse />} />
                            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
                            <Route path="/nouveau" element={<NewEvent />} />
                            <Route path="/mes-alentours" element={<MesAlentours />} />
                            <Route path="/ville-quebec/evenements-cette-semaine" element={<ThisWeek />} />
                            <Route path="/ville-quebec/aujourdhui" element={<Today />} />
                            <Route path="/ville-quebec/activites-gratuites" element={<Gratuit />} />
                            <Route path="/ville-quebec/activites-familiales" element={<Familiales />} />
                            <Route path="/abonnement" element={<Subscription />} />
                            <Route path="/organisateurs" element={<ForOrganizers />} />
                        </Routes>
                    </Suspense>
                </div>
                {/* <GoogleAdsense /> */}
                <Footer />
            </ModalProvider>
            </div>
        </BrowserRouter>
    );
};

export default App;
